export default __webpack_public_path__ + "static/media/tucows.3c8c173a.png";